import { render } from "./DialogSimp.vue?vue&type=template&id=71b9636a"
import script from "./DialogSimp.vue?vue&type=script&lang=js"
export * from "./DialogSimp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__